import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/functional-food";

export const pagingNutraceuticals = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getNutraceuticalsById = (nutraceuticalsId) =>
  axios.get(API_PATH + "/get-by-id/" + nutraceuticalsId);

export const saveNutraceuticals = (nutraceuticals) =>
  axios.post(API_PATH + "/save", nutraceuticals);

export const deleteNutraceuticals = (nutraceuticalsId) =>
  axios.delete(API_PATH + "/mark-delete/" + nutraceuticalsId);
